<template>
	<div class="qa_box" ref="qa">
		<!-- 搜索框 -->
		<div class="search_box border_theme">
			<input v-model="search_value" ref="input" type="text" placeholder="请输入需要搜索的内容">
			<i class="search_icon" @click="getHelps"></i>
		</div>
		<!-- 搜索框 end -->
		
		<div style="margin-top: 28px;">
			<empty v-if="!helps.length"></empty>
			
			<qa v-for="v in helps" :key="v.id" :data="v"></qa>
		</div>
	</div>
</template>

<script>
	import Qa from './components/qa.vue';
	import Api from '../../../../../api/api.js';
	import { mapMutations } from 'vuex';
	
	export default {
		props: {
			data: {
				type: Array,
				default() { return []; }
			}
		},
		mounted() {
			this.data.length && (this.helps = [...this.data]);
		},
		data() {
			return {
				search_value: '',
				helps: []
			}
		},
		methods: {
			/****************** @Events *********************/
			// 获取帮助列表
			getHelps() {
				const that = this;
				that.setLoading(true);
				let requestData = {
					id: 0,
					query: that.search_value
				};
				Api.findHelpList(requestData).then((res) => {
					if (res.data.success) {
						that.setLoading(false);
						that.helps = res.data.data || [];
					} else {
						that.setLoading(false);
						that.swal(res.data.message, {button: false});
					}
				}, (e) => {
					that.setLoading(false);
					that.swal(e.message, {button: false});
				});
			},
			
			/****************** @Function *********************/
			// 获取距离顶部距离
			getOffset(callBack) {
				callBack && callBack(this.$refs.qa.offsetTop + 120);
			},
			
			...mapMutations({
				'setLoading': 'setLoading'
			})
		},
		watch: {
			data(newVal) {
				this.helps = [...newVal];
			}
		},
		components: {
			Qa
		}
	}
</script>

<style scoped>
	.qa_box{ width: 1200px;margin: 30px auto 0;padding: 55px 120px 90px 120px;border-radius: 10px;background: #fff;overflow: hidden; }
	.qa_box .search_box{ position: relative;width: 730px;height: 50px;margin: 0 auto;padding: 5px 55px 5px 25px;border-width: 1px;border-style: solid;border-radius: 25px;  }
	.qa_box .search_box .search_icon{ display: block;position: absolute;width: 25px;height: 25px;top: 11.5px;right: 20px;background-image: url(../../../../../assets/search.png);cursor: pointer; }
	.qa_box .search_box input{ display: block;width: 100%;height: 38px;background: transparent;font-size: 16px;line-height: 38px; }
</style>
